import { HttpClient } from 'api/http-client';
import { AdvancedSetting } from './settings-types';

const base = '/account/config';

class AdvancedSettingsHTTPClient extends HttpClient {
  public getAdvancedSettingsConfig = (): Promise<AdvancedSetting[]> =>
    this.get<AdvancedSetting[]>(base);

  public updateAdvancedSettingsConfig = (
    data: AdvancedSetting,
  ): Promise<void> => this.put(base, data);
}

export const AdvancedSettingsAPI = new AdvancedSettingsHTTPClient();
